import React from "react";
/* eslint-disable no-nested-ternary */
import styled from "styled-components";
import { useLeadOrigens } from "services/api/AppWeb_Lead/lead-origens";
import * as Styles from "../../styles";

interface Props {
  closeModal: () => void;
  idLead?: string;
  idLeadCorretor?: string;
}

const LeadOrigemModal: React.FC<Props> = ({ idLeadCorretor }) => {
  const { data, isLoading } = useLeadOrigens({
    queryKey: "lead-origens",
    enabled: !!idLeadCorretor,
    idLeadCorretor,
  });

  const listaOrigens = data?.data || [];

  return (
    <Styles.ContentModal>
      <TableContainer>
        <StyledTable>
          <thead>
            <tr>
              <th>Origem</th>
              <th>Canal</th>
              <th>Produto</th>
              <th>Data de cadastro</th>
            </tr>
          </thead>
          <BodyScroll>
            {isLoading ? (
              <tr>
                <td
                  colSpan={4}
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  Carregando...
                </td>
              </tr>
            ) : listaOrigens.length === 0 ? (
              <tr>
                <td
                  colSpan={4}
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  Nenhuma origem encontrada
                </td>
              </tr>
            ) : (
              listaOrigens.map((origem: any) => (
                <tr>
                  <td>{origem.origem || "-"}</td>
                  <td>{origem.canal || "-"}</td>
                  <td>{origem.produto || "-"}</td>
                  <td>{origem.data || "-"}</td>
                </tr>
              ))
            )}
          </BodyScroll>
        </StyledTable>
      </TableContainer>
    </Styles.ContentModal>
  );
};

export default LeadOrigemModal;

const TableContainer = styled.div`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  thead,
  tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }

  thead th {
    text-align: left;
    font-family: Inter;
    font-size: 14px;
    font-weight: 600;
    color: #667085;
    background: #f8fafc;
    padding: 12px 12px;
    border-bottom: 1px solid #e5e7eb;
    position: sticky;
    top: 0;
    z-index: 2;
  }

  thead th:first-child {
    border-top-left-radius: 12px;
  }
  thead th:last-child {
    border-top-right-radius: 12px;
  }

  tbody td {
    padding: 16px;
    font-family: Inter;
    font-size: 14px;
    color: #111827;
    border-top: 1px solid #e5e7eb;
    background: #ffffff;
  }

  tbody tr:first-child td {
    border-top: none;
  }
`;

const BodyScroll = styled.tbody`
  display: block;
  max-height: 420px;
  overflow-y: auto;

  /* WebKit scrollbar */
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #2d5bff;
    border-radius: 8px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #2d5bff;
  }

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: transparent;
`;
